import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ActionsCloseBoldIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M14.3 12.179c-.047-.047-.073-.11-.073-.177 0-.066.026-.13.073-.177l9.263-9.262c.586-.587.585-1.537-.001-2.122-.587-.586-1.537-.586-2.123.001L12.177 9.7c-.047.047-.11.073-.177.073-.066 0-.13-.026-.177-.073L2.561.442C1.975-.144 1.026-.144.44.442c-.586.585-.587 1.535 0 2.121l9.26 9.262c.047.047.074.11.074.177 0 .066-.027.13-.074.177L.44 21.442c-.38.38-.528.931-.389 1.45.14.517.544.921 1.061 1.06.518.138 1.07-.01 1.45-.389l9.261-9.263c.047-.047.11-.073.177-.073.067 0 .13.026.177.073l9.262 9.263c.586.586 1.536.586 2.122 0 .586-.585.586-1.535 0-2.121l-9.26-9.263z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ActionsCloseBoldIcon = __decorateClass([
  customElement("elm-actions-close-bold-icon")
], ActionsCloseBoldIcon);
export { ActionsCloseBoldIcon };
